import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import { getRequest, postRequest, putRequest } from '../../../requestUtils';
import ProjectLoadingIndicator from '../ProjectLoadingIndicator';
import SuggestingQualificationsLoader from './SuggestingQualificationsLoader';
import ExpertiseTagDropdown from '../../common/ExpertiseTagDropdown';
import '../ProjectDetails.scss';

// Maps the category labels returned by ProjectTagSuggester to our internal model keys
var SUGGESTION_CATEGORY_TO_MODEL = {
  'Functional Area': 'area_of_expertise',
  'Therapeutic Areas': 'therapeutic_area',
  'Diseases/Indications': 'disease_code',
  'Product Technologies': 'therapy',
  'Regulatory Pathway': 'regulatory_pathway',
  'Phases of Development': 'development_phase',
  Education: 'degree',
  Skills: 'skill'
};
var models = ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'];
var formStep = 'qualifications';
var maxItems = 100;
var filterPicklist = function filterPicklist(picklist, input) {
  return picklist.filter(function (record) {
    return record.label.toLowerCase().includes(input.toLowerCase());
  }).slice(0, maxItems);
};
var ProjectExpertise = /*#__PURE__*/function (_Component) {
  function ProjectExpertise(props) {
    var _this;
    _classCallCheck(this, ProjectExpertise);
    _this = _callSuper(this, ProjectExpertise, [props]);
    // Only auto-suggest for a JD-imported project, and only once per project — both gated on
    // persisted, server-side signals rather than anything carried in the URL or inferred from
    // component state:
    // - createdFromJobDescription (was this project created from a JD?) comes from whether
    //   raw_job_description_text is present, NOT from the `jobDescriptionUpload` prop's
    //   `jd_success` URL param, which only exists on the one page load right after upload — any
    //   later full page reload (an ordinary browser refresh, not just wizard back/forward nav)
    //   drops it from the URL and would otherwise disable suggestions for the rest of the
    //   project's session.
    // - suggestionsAlreadyFetched (has a fetch already been attempted?) is set by the backend the
    //   first time one is attempted, success or failure — not inferred from tag counts, since
    //   this step fully unmounts/remounts on every wizard back/forward navigation and the
    //   server-side tags stay empty until the user actually saves.
    _defineProperty(_this, "maybeFetchSuggestions", function () {
      var _this$props = _this.props,
        jobDescriptionUpload = _this$props.jobDescriptionUpload,
        projectResourceId = _this$props.projectResourceId;
      var _this$state = _this.state,
        suggestionsAlreadyFetched = _this$state.suggestionsAlreadyFetched,
        createdFromJobDescription = _this$state.createdFromJobDescription;
      if (!jobDescriptionUpload && !createdFromJobDescription || !projectResourceId || suggestionsAlreadyFetched) return;
      _this.fetchSuggestions();
    });
    _defineProperty(_this, "fetchSuggestions", function () {
      var _this$props2 = _this.props,
        projectResourceId = _this$props2.projectResourceId,
        csrfToken = _this$props2.csrfToken;
      _this.setState({
        loadingSuggestions: true,
        suggestionsAlreadyFetched: true
      });
      getRequest("/projects/".concat(projectResourceId, "?form_step=review")).then(function (_ref) {
        var data = _ref.data;
        var payload = {
          title: data.name,
          description: data.description,
          ideal_candidate_description: data.ideal_candidate_description,
          responsibilities: data.responsibility_areas || [],
          raw_text: data.raw_job_description_text,
          project_resource_id: projectResourceId
        };
        return postRequest('/projects/suggest_tags', payload, csrfToken);
      }).then(function (_ref2) {
        var data = _ref2.data;
        var suggestedTagLabels = {};
        Object.keys(data.tags || {}).forEach(function (category) {
          var model = SUGGESTION_CATEGORY_TO_MODEL[category];
          if (!model) return;
          suggestedTagLabels[model] = data.tags[category];
        });
        var suggestedCount = Object.values(suggestedTagLabels).reduce(function (sum, labels) {
          return sum + (labels ? labels.length : 0);
        }, 0);
        // Fired at fetch time (independent of the submit-time acceptance event) so product
        // can tell "AI returned zero suggestions" and "fetch failed" apart from "the user
        // just didn't accept them" when reading the 50%-acceptance success metric.
        analyticsTrack('Fetched Suggested Qualifications', {
          location: 'Project creation',
          suggested_count: suggestedCount
        });
        _this.setState({
          suggestedTagLabels: suggestedTagLabels,
          loadingSuggestions: false
        }, _this.applySuggestionsIfAny);
      })["catch"](function () {
        analyticsTrack('Fetched Suggested Qualifications', {
          location: 'Project creation',
          suggested_count: 0,
          fetch_failed: true
        });
        _this.setState({
          loadingSuggestions: false
        });
      });
    });
    _defineProperty(_this, "applySuggestionsIfAny", function () {
      var _this$state2 = _this.state,
        suggestedTagLabels = _this$state2.suggestedTagLabels,
        expertiseTags = _this$state2.expertiseTags,
        expertisePicklists = _this$state2.expertisePicklists,
        notApplicable = _this$state2.notApplicable;
      if (!suggestedTagLabels || !expertisePicklists || !expertiseTags) return;
      var updated = _objectSpread({}, expertiseTags);
      var suggestedIds = {};
      // Skill and Education (degree) suggestions are freeform on the backend (not filtered
      // against the picklist), so unmatched labels become `custom:` chips here rather than
      // being dropped — ProjectService#process_custom_company_tags turns these into real,
      // company-scoped records on save. Every other category is a closed picklist.
      var creatableModels = ['skill', 'degree'];
      var labelToId = function labelToId(model, label) {
        var options = expertisePicklists[model] || [];
        var normalized = label.trim().toLowerCase();
        // Degree records are named "<Abbreviation> (<Full name>)" (e.g. "PhD (Doctor of
        // Philosophy)"), but the AI is free to answer with just "PhD" since Education isn't
        // filtered against this list. Without this, a real match would be missed and become an
        // unnecessary duplicate custom chip instead of resolving to the existing record.
        var pick = options.find(function (opt) {
          return opt.label.trim().toLowerCase() === normalized;
        }) || (model === 'degree' ? options.find(function (opt) {
          return opt.label.trim().toLowerCase().startsWith("".concat(normalized, " ("));
        }) : undefined);
        if (pick) return pick.value;
        return creatableModels.includes(model) ? "custom:".concat(label) : null;
      };
      models.forEach(function (model) {
        var labels = suggestedTagLabels[model];
        if (!labels || notApplicable.includes(model)) return;
        var ids = labels.map(function (l) {
          return labelToId(model, l);
        }).filter(function (v) {
          return v !== null;
        });
        if (ids.length === 0) return;
        var current = Array.isArray(updated["".concat(model, "_ids")]) ? updated["".concat(model, "_ids")] : [];
        if (model === 'area_of_expertise') {
          // Don't clobber an Area of Expertise the wizard already set from the chosen
          // Role (see maybeFetchSuggestions) — only apply the AI's guess if nothing is set yet.
          // If it's not applied, it wasn't a real suggestion to the user, so don't record it as
          // one either (it would otherwise inflate both suggested_count and accepted_count with
          // a value the AI never actually contributed).
          if (current.length === 0) {
            updated["".concat(model, "_ids")] = [ids[0]];
            suggestedIds[model] = [ids[0]];
          }
        } else {
          // Track only the AI-derived ids, not the merged result — `current` may already hold
          // pre-existing selections that aren't suggestions and shouldn't count as one.
          updated["".concat(model, "_ids")] = Array.from(new Set([].concat(_toConsumableArray(current || []), _toConsumableArray(ids))));
          suggestedIds[model] = ids;
        }
      });
      _this.setState({
        expertiseTags: updated,
        suggestedIds: suggestedIds
      });
    });
    _this.state = {
      showModal: false,
      errors: null,
      expertiseTags: null,
      expertisePicklists: {},
      notApplicable: [],
      loadingSuggestions: false,
      suggestedTagLabels: null,
      suggestedIds: {},
      suggestionsAlreadyFetched: false,
      createdFromJobDescription: false
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleBack = _this.handleBack.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleCreate = _this.handleCreate.bind(_this);
    _this.handleToggleNotApplicable = _this.handleToggleNotApplicable.bind(_this);
    return _this;
  }
  _inherits(ProjectExpertise, _Component);
  return _createClass(ProjectExpertise, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props3 = this.props,
        projectResourceId = _this$props3.projectResourceId,
        getProjectDetails = _this$props3.getProjectDetails;
      if (!projectResourceId) return;
      getProjectDetails(formStep).then(function (_ref3) {
        var data = _ref3.data;
        _this2.setState({
          expertiseTags: data.expertise_tags,
          expertisePicklists: data.expertise_picklists || {},
          notApplicable: data.not_applicable,
          suggestionsAlreadyFetched: !!data.qualifications_suggestions_fetched,
          createdFromJobDescription: !!data.created_from_job_description
        }, _this2.maybeFetchSuggestions);
      });
    }
  }, {
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var _this$state3 = this.state,
        expertiseTags = _this$state3.expertiseTags,
        notApplicable = _this$state3.notApplicable;
      var tagSum = models.reduce(function (aggr, model) {
        return aggr + expertiseTags["".concat(model, "_ids")].length;
      }, 0);

      // to be able to submit, every model should either have tags or be not applicable.
      return models.every(function (model) {
        return expertiseTags["".concat(model, "_ids")].length > 0 || notApplicable.includes(model) || ['degree', 'skill', 'language', 'accreditation'].includes(model);
      }) && tagSum >= 3;
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      var _this$props4 = this.props,
        formType = _this$props4.formType,
        back = _this$props4.back;
      if (formType === 'page') {
        back();
      } else {
        this.handleHideModal();
      }
    }
  }, {
    key: "trackSuggestionAcceptance",
    value: function trackSuggestionAcceptance() {
      var _this$state4 = this.state,
        suggestedIds = _this$state4.suggestedIds,
        expertiseTags = _this$state4.expertiseTags;
      var suggestedCount = Object.values(suggestedIds).reduce(function (sum, ids) {
        return sum + ids.length;
      }, 0);
      if (suggestedCount === 0) return;
      var acceptedCount = Object.keys(suggestedIds).reduce(function (sum, model) {
        var finalIds = expertiseTags["".concat(model, "_ids")] || [];
        var kept = suggestedIds[model].filter(function (id) {
          return finalIds.includes(id);
        });
        return sum + kept.length;
      }, 0);
      analyticsTrack('Saved Suggested Qualifications', {
        location: 'Project creation',
        suggested_count: suggestedCount,
        accepted_count: acceptedCount
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props5 = this.props,
        csrfToken = _this$props5.csrfToken,
        projectResourceId = _this$props5.projectResourceId,
        afterSubmit = _this$props5.afterSubmit;
      var _this$state5 = this.state,
        expertiseTags = _this$state5.expertiseTags,
        notApplicable = _this$state5.notApplicable;
      var projectAttributes = _objectSpread({}, expertiseTags);
      models.forEach(function (model) {
        if (model === 'therapy') {
          projectAttributes.therapies_not_applicable = notApplicable.includes(model);
        } else {
          projectAttributes["".concat(model, "s_not_applicable")] = notApplicable.includes(model);
        }
      });
      putRequest("/projects/".concat(projectResourceId), {
        project: projectAttributes
      }, csrfToken).then(function () {
        // Only fired once the save actually succeeds — firing it before the request settles
        // would record an "acceptance" even when the save failed and nothing persisted.
        _this3.trackSuggestionAcceptance();
        afterSubmit();
      })["catch"](function (error) {
        _this3.setState({
          errors: error.name
        });
        return null;
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(model, multi) {
      var _this4 = this;
      var expertiseTags = this.state.expertiseTags;
      return function (tags) {
        var allTags = expertiseTags;
        if (multi) {
          allTags["".concat(model, "_ids")] = tags.map(function (tag) {
            return tag.value;
          });
        } else {
          allTags["".concat(model, "_ids")] = tags.length >= 1 ? [tags[tags.length - 1].value] : [];
        }
        if (tags.length >= 1) {
          analyticsTrack("Selected ".concat(model, ": ").concat(tags[tags.length - 1].label), {
            location: 'Project creation'
          });
        } else {
          analyticsTrack("Cleared ".concat(model, " tags"), {
            location: 'Project creation'
          });
        }
        _this4.setState({
          expertiseTags: allTags
        });
      };
    }
  }, {
    key: "handleCreate",
    value: function handleCreate(model, multi) {
      var _this5 = this;
      var expertiseTags = this.state.expertiseTags;
      return function (inputValue) {
        var allTags = expertiseTags;
        if (multi) {
          allTags["".concat(model, "_ids")].push("custom:".concat(inputValue));
        } else {
          allTags["".concat(model, "_ids")] = ["custom:".concat(inputValue)];
        }
        _this5.setState({
          expertiseTags: allTags
        });
      };
    }
  }, {
    key: "handleToggleNotApplicable",
    value: function handleToggleNotApplicable(e) {
      var _this$state6 = this.state,
        expertiseTags = _this$state6.expertiseTags,
        notApplicable = _this$state6.notApplicable;
      var model = e.target.dataset.model;
      var newExpertiseTags = _objectSpread({}, expertiseTags);
      analyticsTrack("Toggled not applicable on ".concat(model), {
        location: 'Project creation'
      });
      if (notApplicable.includes(model)) {
        var modelIndex = notApplicable.findIndex(function (elm) {
          return elm === model;
        });
        notApplicable.splice(modelIndex, 1);
        if (model === 'therapeutic_area') {
          var diseaseIndex = notApplicable.findIndex(function (elm) {
            return elm === 'disease_code';
          });
          if (diseaseIndex !== -1) notApplicable.splice(diseaseIndex, 1);
        }
      } else {
        notApplicable.push(model);
        newExpertiseTags["".concat(model, "_ids")] = [];
        if (model === 'therapeutic_area' && !notApplicable.includes('disease_code')) {
          notApplicable.push('disease_code');
        }
      }
      this.setState({
        notApplicable: notApplicable,
        expertiseTags: newExpertiseTags
      });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "add-coworkers-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "add-coworkers-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props6 = this.props,
        backButtonText = _this$props6.backButtonText,
        submitButtonText = _this$props6.submitButtonText;
      return /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, backButtonText), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSubmit,
        disabled: !this.ableToSubmit()
      }, submitButtonText));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      return errors && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, "Errors prohibited this project from being saved:"), /*#__PURE__*/React.createElement("ul", null, errors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", null, e);
      })));
    }
  }, {
    key: "renderMessages",
    value: function renderMessages() {
      var expertiseTags = this.state.expertiseTags;
      var tagSum = models.reduce(function (aggr, model) {
        return aggr + expertiseTags["".concat(model, "_ids")].length;
      }, 0);
      return /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("ul", null, expertiseTags.area_of_expertise_ids.length === 0 ? /*#__PURE__*/React.createElement("li", null, "Functional Area must be selected.") : '', expertiseTags.area_of_expertise_ids.length && tagSum >= 1 && tagSum < 3 ? /*#__PURE__*/React.createElement("li", null, "At least 3 tags must be applied describing the project.") : '', expertiseTags.area_of_expertise_ids.length && tagSum >= 3 && !this.ableToSubmit() ? /*#__PURE__*/React.createElement("li", null, "Each section must have at least one tag or marked 'Not Applicable'.") : ''));
    }
  }, {
    key: "renderNotApplicableCheckbox",
    value: function renderNotApplicableCheckbox(model) {
      var notApplicable = this.state.notApplicable;
      return /*#__PURE__*/React.createElement("div", {
        className: "not-applicable-checkbox"
      }, /*#__PURE__*/React.createElement("label", {
        className: "custom-checkbox-container",
        htmlFor: "notApplicable-".concat(model)
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        "data-model": model,
        onClick: this.handleToggleNotApplicable,
        id: "notApplicable-".concat(model),
        checked: notApplicable.includes(model)
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text"
      }, "Not applicable")));
    }
  }, {
    key: "renderSelect",
    value: function renderSelect(model, heading, asyncUrl, isCreate, multi, notApplicableCheckbox) {
      var _this$state7 = this.state,
        expertiseTags = _this$state7.expertiseTags,
        notApplicable = _this$state7.notApplicable,
        expertisePicklists = _this$state7.expertisePicklists;
      var picklist = expertisePicklists[model] || [];
      var selection = expertiseTags["".concat(model, "_ids")].map(function (id) {
        var foundOption = picklist.find(function (option) {
          return option.value === id;
        });
        return foundOption || (typeof id === 'string' ? {
          label: id.slice(7),
          value: id
        } : undefined);
      }).filter(Boolean);
      var disabled = notApplicable.includes(model);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(model)
      }, /*#__PURE__*/React.createElement(ExpertiseTagDropdown, {
        model: model,
        selection: selection,
        handleSelect: this.handleSelect,
        handleCreate: this.handleCreate,
        multi: multi,
        isValidNewOption: function isValidNewOption() {
          return isCreate;
        },
        isCreatable: isCreate,
        heading: heading,
        isDisabled: disabled,
        picklist: picklist,
        loadOptions: function loadOptions(input) {
          return new Promise(function (resolve) {
            resolve(filterPicklist(picklist, input));
          });
        },
        groupStyle: model === 'degree'
      }), notApplicableCheckbox && this.renderNotApplicableCheckbox(model));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (!this.state.expertiseTags) {
        return /*#__PURE__*/React.createElement(ProjectLoadingIndicator, null);
      }
      if (this.state.loadingSuggestions) {
        return /*#__PURE__*/React.createElement(SuggestingQualificationsLoader, null);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-expertise-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6 expertise-entry-container"
      }, this.renderErrors(), /*#__PURE__*/React.createElement("h2", null, "Qualifications"), /*#__PURE__*/React.createElement("div", {
        className: "heading-subtext"
      }, "Select qualifications and skills required for your project"), /*#__PURE__*/React.createElement("br", null), this.renderSelect('area_of_expertise', 'Functional Areas', '', false, false, false), this.renderSelect('therapeutic_area', 'Therapeutic Areas', '', false, true, true), this.renderSelect('disease_code', 'Diseases and indications', '/users/autocomplete_disease_code', false, true, true), this.renderSelect('therapy', 'Product Technologies', '', false, true, true), this.renderSelect('regulatory_pathway', 'Regulatory Pathways', '', false, true, true), this.renderSelect('development_phase', 'Development Phases', '', false, true, true), this.renderSelect('degree', 'Highest Education', '', false, true, false), this.renderSelect('language', 'Language', '', false, true, false), this.renderSelect('accreditation', 'Certification', '', false, true, false), this.renderSelect('skill', 'Other Keywords / Skills', '', true, true, false), this.renderMessages(), this.renderButtons())));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      return /*#__PURE__*/React.createElement("i", {
        role: "button",
        tabIndex: 0,
        className: "fa fa-edit modal-link",
        onClick: this.handleShowModal
      }, this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(Component);
ProjectExpertise.propTypes = {
  formType: PropTypes.string,
  // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  jobDescriptionUpload: PropTypes.bool
};
ProjectExpertise.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  back: function back() {},
  afterSubmit: function afterSubmit() {},
  backButtonText: 'Back',
  submitButtonText: 'Next',
  jobDescriptionUpload: false
};
export default ProjectExpertise;